var _ellipse, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.144,
    cy: -19.123,
    rx: 189.813,
    ry: 189.273,
    transform: "rotate(24.458 31.144 -19.123)",
    fill: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.308,
    cy: -19.049,
    r: 154.729,
    transform: "rotate(24.458 31.308 -19.05)",
    fill: "#EA1889"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.728 154.728 0 1 0-50.901 61.839L31.308-19.049l140.845 64.062Z",
    fill: "#9F18D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.727 154.727 0 0 0-42.512-183.527 154.736 154.736 0 0 0-188.277-6.437 154.728 154.728 0 0 0-54.947 180.196 154.731 154.731 0 0 0 159.834 99.712L31.308-19.049l140.845 64.062Z",
    fill: "#57F2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.734 154.734 0 0 0-27.76-169.67A154.731 154.731 0 0 0-123.331-24.335a154.731 154.731 0 0 0 90.577 146.131L31.308-19.049l140.845 64.062Z",
    fill: "#EA1889"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013A154.732 154.732 0 0 0 95.37-159.894a154.732 154.732 0 0 0-204.906 76.783A154.722 154.722 0 0 0-94.593 70.895L31.308-19.049l140.845 64.062Z",
    fill: "#9F18D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.736 154.736 0 0 0-4.28-136.803A154.734 154.734 0 0 0-74.3-132.133 154.737 154.737 0 0 0-122.698-4.106L31.308-19.049l140.845 64.062Z",
    fill: "#57F2B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013A154.729 154.729 0 1 0-109.536-83.111L31.308-19.049l140.845 64.062Z",
    fill: "#EA1889"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.727 154.727 0 0 0-42.512-183.527 154.736 154.736 0 0 0-188.277-6.437L31.308-19.049l140.845 64.062Z",
    fill: "#9F18D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013A154.732 154.732 0 0 0 95.37-159.894a154.732 154.732 0 0 0-79.005-13.161L31.308-19.049l140.845 64.062Z",
    fill: "#57F2B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.72 154.72 0 0 0 4.046-118.356 154.734 154.734 0 0 0-80.829-86.551L31.308-19.049l140.845 64.062Z",
    fill: "#EA1889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.732 154.732 0 0 0-14.943-154.006L31.308-19.049l140.845 64.062Z",
    fill: "#9F18D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.153 45.013a154.732 154.732 0 0 0 13.161-79.005L31.308-19.05l140.845 64.062Z",
    fill: "#57F2B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.219,
    cy: -19.287,
    r: 25.009,
    transform: "rotate(24.458 31.22 -19.287)",
    fill: "#D396ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.219,
    cy: -19.287,
    r: 14.933,
    transform: "rotate(24.458 31.219 -19.287)",
    fill: "#57F2B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(443.95465 487.23995 -488.62886 445.22017 -83.147 -344.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#4B00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B00CC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeft);
export default __webpack_public_path__ + "static/media/top-left.24f512926054bf6b0393cd4e9eb616e0.svg";
export { ForwardRef as ReactComponent };